import { TreeNode } from 'react-organizational-chart';
import React from 'react';
import NodeCard from './components/NodeCard/NodeCard';

export default function OrgTreeNode({
  node,
  addChild,
  onEditClick,
  onDeleteClick,
  children,
  users = [],
  showViewButtonInNode = false,
  showEditButtonInNode = true,
  showAddChildButtonInNode = true,
  showDeleteButtonInNode = true,
}) {
  return (
    <TreeNode
      key={node.id}
      label={
        <NodeCard
          node={node}
          addChild={addChild}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          users={users}
          showViewButtonInNode={showViewButtonInNode}
          showEditButtonInNode={showEditButtonInNode}
          showAddChildButtonInNode={showAddChildButtonInNode}
          showDeleteButtonInNode={showDeleteButtonInNode}
        />
      }
    >
      {children}
    </TreeNode>
  );
}

export { NodeCard };
